module.exports = __webpack_public_path__ + "static/media/logo.09c301e2.svg";